import { Link } from 'react-router-dom';
import { Coins, LogOut, Settings } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * MobileNav — slide-down menu shown on small screens.
 */
export default function MobileNav({
  navItems, iconMap, location,
  user, onLogin, onRegister, onLogout,
}) {
  return (
    <div className="md:hidden glass border-t border-white/5" data-testid="mobile-nav">
      <ul className="px-4 py-3 space-y-1">
        {navItems.map((item) => {
          const Icon = iconMap[item.icon];
          const active = location.pathname === item.path;
          return (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium ${active ? 'bg-white/10 text-white' : 'text-zinc-300 hover:bg-white/5'}`}
              >
                <Icon size={18} />{item.name}
              </Link>
            </li>
          );
        })}
        {user ? (
          <>
            <li className="flex items-center justify-between pt-2 mt-2 border-t border-white/5">
              <div className="flex items-center gap-2 text-sm">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-pink-500 to-purple-600 flex items-center justify-center">{user.avatar}</div>
                <span className="font-semibold">{user.username}</span>
              </div>
              <div className="flex items-center gap-1.5 text-sm">
                <Coins size={14} className="text-yellow-400" />
                <span className="font-semibold">{user.coins}</span>
              </div>
            </li>
            <li>
              <Link to="/settings" className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-zinc-300 hover:bg-white/5" data-testid="mobile-settings">
                <Settings size={18} /> Paramètres
              </Link>
            </li>
            <li>
              <button onClick={onLogout} className="w-full text-left px-3 py-2 text-sm text-pink-400 font-medium" data-testid="mobile-logout">
                <LogOut size={14} className="inline mr-2" /> Déconnexion
              </button>
            </li>
          </>
        ) : (
          <li className="flex gap-2 pt-2 mt-2 border-t border-white/5">
            <Button onClick={onLogin} variant="outline" className="flex-1 bg-white/5 text-white border-white/15 rounded-xl h-9 text-sm">Connexion</Button>
            <Button onClick={onRegister} className="flex-1 btn-neon text-white border-0 rounded-xl h-9 text-sm font-semibold">S&apos;inscrire</Button>
          </li>
        )}
      </ul>
    </div>
  );
}
